export const configuration = {
  dev: {
    // url: 'https://dev.nuralsales.app/api',
    // url: 'http://3.109.148.242:8000/api',
    url: 'https://nural-api.applore.in/api',
  },
  dev_phase3: {
    // url: 'https://dev.nuralsales.app/api',
    // url: 'http://3.109.148.242:8001/api',
    // url: 'https://phase3-api.nuralsales.app/api',
    url: 'https://nural-api.applore.in/api',
    // url: 'http://localhost:4050/api',
  },
  demo: {
    url: 'http://3.109.148.242:8001/api',
  },
  qa: {
    url: 'https://dev.nuralsales.app/api',
  },
  prod: {
    // url: 'http://3.109.180.225:8002/api',
    // url: 'https://prod-node.nuralsales.app/api',
    url: 'http://35.154.121.21:5000/api',
    // url: 'https://temp-test.jktyre.co.in/api',
  },
  local: {
    url: 'https://e489-223-233-66-155.ngrok.io/api',
    // url: 'http://localhost:5001/api',
  },
  local_prod: {
    url: 'http://localhost:8002/api',
  },
  local_dev:{
    url: "http://localhost:8001/api"
  }
}
